export default __webpack_public_path__ + "i18n/ja.334608a86a3ffd49eb6a5939ea605bae.json";